export const MAX_SERVICES = 4;

export const MAX_CERTIFICATIONS = 10;

export const MAX_CERTIFICATION_LENGTH = 256;

export const MAX_STORE_CODE_LENGTH = 64;

export const MAX_ADDITIONAL_PHONES = 2;

export const MAX_ADDITIONAL_CATEGORIES = 9;

export const MAX_FACEBOOK_DAY_INTERVALS = 3;

export const DEFAULT_HOURS_INTERVAL = { from: '09:00', to: '18:00' };

export const COMPANY_STATUS = {
    OPEN: 1,
    CLOSED: 2,
};

export const ChatType = {
    SMS: 0,
    WhatsApp: 1,
};

export const LocatedInRelationType = {
    Independent: 0,
    Department: 1,
};

export const locatedInRelationTypeLabelKey = relationType =>
    relationType === LocatedInRelationType.Department
        ? 'SettingsCompanies.relationDepartment'
        : 'SettingsCompanies.relationIndependent';

export const googleMapsPlaceUrl = placeId => `https://www.google.com/maps/place/?q=place_id:${placeId}`;

export const Completeness = {
    Critical: 1,
    Low: 2,
    Average: 3,
    Good: 4,
    Excellent: 5,
};

// Backend (LocationsTools.ApplyCompletenessScore) is the source of truth for the score → level
// mapping; the API ships `completenessLevel` on every location DTO. Use this fallback only when
// the level isn't available (e.g. a freshly-built object before persistence).
export const completenessLevelForScore = score => {
    if (score >= 90) return Completeness.Excellent;
    if (score >= 70) return Completeness.Good;
    if (score >= 50) return Completeness.Average;
    if (score >= 25) return Completeness.Low;
    return Completeness.Critical;
};

export const resolveCompletenessLevel = company =>
    company?.completenessLevel ?? completenessLevelForScore(company?.completeness ?? 0);

export const COMPLETENESS_LEVEL_TRANSLATION_KEY = {
    [Completeness.Critical]: 'common.critical',
    [Completeness.Low]: 'common.low',
    [Completeness.Average]: 'common.average',
    [Completeness.Good]: 'common.good',
    [Completeness.Excellent]: 'common.excellent',
};

export const OPTIMIZATION_BUCKET = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high',
};

export const OPTIMIZATION_BUCKET_LEVELS = {
    [OPTIMIZATION_BUCKET.LOW]: [Completeness.Critical, Completeness.Low],
    [OPTIMIZATION_BUCKET.MEDIUM]: [Completeness.Average],
    [OPTIMIZATION_BUCKET.HIGH]: [Completeness.Good, Completeness.Excellent],
};

export const paymentMethods = [
    { name: 'cash', value: 1 },
    { name: 'visa', value: 2 },
    { name: 'mastercard', value: 3 },
    { name: 'applePay', value: 4 },
    { name: 'androidPay', value: 5 },
    { name: 'paypal', value: 6 },
    { name: 'americanExpress', value: 7 },
    { name: 'discover', value: 8 },
    { name: 'invoice', value: 9 },
    { name: 'bitcoin', value: 10 },
    { name: 'travelersCheck', value: 11 },
    { name: 'dinersClub', value: 12 },
    { name: 'insurance', value: 13 },
];

export const PaymentTypes = {
    cash: 1,
    visa: 2,
    mastercard: 3,
    applePay: 4,
    androidPay: 5,
    paypal: 6,
    americanExpress: 7,
    discover: 8,
    invoice: 9,
    bitcoin: 10,
    travelersCheck: 11,
    dinersClub: 12,
    insurance: 13,
};

export const APPLE_PAY_UNSUPPORTED_COUNTRIES = ['PT', 'BR'];

export const LocationIntegrationStatus = {
    Connected: 1,
    Disconnected: 2,
    Unverified: 3,
    Pending: 4,
};

export const LocationType = {
    Location: 1,
    HealthcareFacility: 2,
    HealthcareProfessional: 3,
    Hotel: 4,
    Restaurant: 5,
};
